
import { logger } from '@utils';
import { SagaIterator } from 'redux-saga';
import { put } from 'redux-saga/effects';
import * as RatingActions from '@services/rating/rating.actions';
import * as EventWebsocket from './event.websocket';

export function* createEvent(action: any): SagaIterator {
  try {
    EventWebsocket.createEvent(action.payload);
    yield put(RatingActions.requestRatingPrompt());
  } catch (error) {
    logger.info(error);
  }
} 

export function* editEvent(action: any): SagaIterator {
  try {
    EventWebsocket.editEvent(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* deleteEvent(action: any): SagaIterator {
  try {
    EventWebsocket.deleteEvent(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* seenEvent(action: any): SagaIterator {
  try {
    EventWebsocket.seenEvent(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* completedEvent(action: any): SagaIterator {
  try {
    EventWebsocket.completedEvent(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* analyzeImage(action: any): SagaIterator {
  try {
    EventWebsocket.analyzeImage(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* analyzeReceiptImage(action: any): SagaIterator {
  try {
    EventWebsocket.analyzeReceiptImage(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* analyzeImageDismiss(action: any): SagaIterator {
  try {
    EventWebsocket.analyzeImageDismiss(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* aiTask(action: any): SagaIterator {
  try {
    EventWebsocket.aiTask(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* dismissAiTask(action: any): SagaIterator {
  try {
    EventWebsocket.dismissAiTask(action.payload);
  } catch (error) {
    logger.info(error);
  }
} 

export function* aiScheduleTurn(action: any): SagaIterator {
  try {
    EventWebsocket.aiScheduleTurn(action.payload);
  } catch (error) {
    logger.info(error);
  }
}

export function* editEventVisibility(action: any): SagaIterator {
  try {
    EventWebsocket.addViewerToEvent(action.payload);
  } catch (error) {
    logger.info(error);
  }
}



// WEBPACK FOOTER //
// ./src/services/events/event.saga.ts